<template>
  <div class="road-wrap">
    <img
      src="../../../assets/MyProgress/road.png"
      alt="road"
      class="road"
      width="1204"
      height="400"
    />

    <div class="img-block">
      <img
        src="../../../assets/MyProgress/road-splash.png"
        alt=""
        class="splash"
        ref="road"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    oldPosition: Number,
    newPosition: Number,
    calcTiming: Function,
    linear: Function,
  },
  data() {
    return {
      road: null,
      positions: [
        { width: 0 },
        { width: 62.5 },
        { width: 125 },
        { width: 187.5 },
        { width: 250 }, // 1000
        { width: 296 },
        { width: 342 },
        { width: 388 },
        { width: 434 },
        { width: 475 }, // 2500
        { width: 505.5 },
        { width: 536 },
        { width: 566.5 },
        { width: 597 },
        { width: 627.5 },
        { width: 658 },
        { width: 688.5 },
        { width: 719 },
        { width: 750 }, // 5000
        { width: 780 },
      ],
    };
  },
  methods: {
    drawRoad(progress) {
      const array = this.positions;
      let prog = Math.round(array.length * progress);

      prog < 20
        ? (this.road.style.width = array[prog].width + "px")
        : (this.road.style.width = "780px");
    },

    animate({ duration, timing, draw }) {
      let start = performance.now();
      let newPosition = this.newPosition;
      let oldPosition = this.oldPosition;

      requestAnimationFrame(function animate(time) {
        let timeFraction = (time - start) / duration + oldPosition;
        if (timeFraction > 1) timeFraction = 1;

        // вычисление текущего состояния анимации
        let progress = timing(timeFraction);

        draw(progress); // отрисовать её

        if (timeFraction < 1 && timeFraction <= newPosition) {
          requestAnimationFrame(animate);
        }
      });
    },

    startAnimation() {
      this.animate({
        duration: 20000,
        timing: this.calcTiming(this.linear),
        draw: this.drawRoad,
      });
    },
  },

  mounted() {
    this.road = this.$refs.road;

    this.startAnimation();
  },
};
</script>

<style scoped>
.img-block {
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 132px;
  margin-top: 27px;

  height: 328px;
  overflow: hidden;
  transition: all 1s linear;
}

.road-wrap {
  position: absolute;
  width: 1204px;
  height: 400px;
  bottom: 0;
}

.splash {
  object-fit: none;
  display: block;
  transition: all 1s linear;
  height: 327px;
  object-position: left top;
}
</style>



// WEBPACK FOOTER //
// Content/src/components/MyProgress/Daccord/Road.vue